function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M.148.138H27.01V27H.15z"
}));

var _ref2 = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(26 50.669)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  d: "M.148 13.569C.148 20.987 6.161 27 13.58 27c7.418 0 13.43-6.014 13.43-13.432 0-7.416-6.013-13.43-13.43-13.43S.15 6.152.15 13.568",
  fill: "#BEFFFC",
  mask: "url(#b)"
})), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M28.778 63.902H1V1h44.111v46.54M6.947 20.796h31.241M6.947 32.39h31.241M6.947 43.986h31.241M17.239 55.58h10.213"
}), React.createElement("path", {
  d: "M32.648 63.903c0 6.908 5.601 12.509 12.51 12.509 6.908 0 12.51-5.601 12.51-12.51 0-6.908-5.602-12.51-12.51-12.51-6.909 0-12.51 5.602-12.51 12.51zM5.627 55.03a3.264 3.264 0 1 0 6.529 0 3.264 3.264 0 1 0-6.53 0z",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M40.614 70.399h9.729v-9.117h-9.729z"
}), React.createElement("path", {
  d: "M48.343 57.565a2.868 2.868 0 0 0-2.865-2.864 2.868 2.868 0 0 0-2.864 2.864v3.718h-.734M15.633 14.986l-5.92-4.927-5.92 4.927V1h11.84v6.895z",
  stroke: "#28348A",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 58 78",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/rules.svg